<template>
  <div>
    <v-navigation-drawer
      v-model="isOpen"
      :width="$isMobile ? '100%' : '50%'"
      right
      fixed
      :permanent="isOpen"
      hide-overlay
      class="z-index--100">
      <div class="ma-3">
        <div class="d-flex">
          <v-btn
            dark
            fab
            x-small
            outlined
            color="primary"
            class="mr-3"
            @click="close"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div>
          <div>
            <v-row>
              <v-col md="12">
                <div class="d-flex align-center">
                  <div class="subtitle-1 primary--text">
                    {{ category }}
                  </div>
                  <v-spacer />
                  <div class="title primary--text">
                    {{ total | toFixNumber(2) | numberWithComma | prefix('$') }}
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="12">
                <v-data-table
                  :headers="headers"
                  :items="data"
                  :items-per-page="200"
                  hide-default-footer
                  item-key="product"
                  sort-by="productName"
                  group-by="period"
                  class="elevation-1 group-results">
                  <template v-slot:group="{ group, items }" cols="2">
                    <tr class="primary lighten-1 font-weight-bold">
                      <td>
                        Periodo: {{ group }}
                      </td>
                      <td>
                        {{ items.reduce((acc, curr) => acc + curr.amount, 0) | toFixNumber(2) | numberWithComma | prefix('$') }}
                      </td>
                    </tr>
                    <tr v-for="(product, index) in items" :key="`prod-${group}-${index}`">
                      <td>
                        {{ product.productName }}
                      </td>
                      <td>
                        {{ product.amount | toFixNumber(2) | numberWithComma | prefix('$') }}
                      </td>
                    </tr>
                  </template>
                  <!-- <template v-slot:body="{ items }">
                    <tr
                      v-for="(r, i) in items"
                      :key="`category-${i}`">
                      <td
                        v-for="(k, j) in headers"
                        :key="`cell-${j}`"
                        :class="j + 1 === headers.length ? 'grey lighten-5' : ''">
                        <div v-if="k.value === 'productName'" style="min-width:170px">
                          {{ r[k.value] }}
                        </div>
                        <div v-else-if="i + 1 === headers.length" style="min-width:170px; text-align: right">
                          <span v-if="r[k.value]">
                            {{ r[k.value] | toFixNumber(2) | numberWithComma | prefix('$') }}
                          </span>
                          <span v-else class="grey--text">
                            Sin datos
                          </span>
                        </div>
                        <div v-else style="min-width:170px; text-align: right">
                          <span v-if="r[k.value]">
                            {{ r[k.value] | toFixNumber(2) | numberWithComma | prefix('$') }}
                          </span>
                          <span v-else class="grey--text">
                            Sin datos
                          </span>
                        </div>
                      </td>
                    </tr>
                  </template> -->
                  <template v-slot:footer>
                    <div class="pa-5" />
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </v-navigation-drawer>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: 'ReportPurchasesByCategoryDetail',
  data () {
    return {
      overlay: false,
      isOpen: false,
      category: '',
      total: 0,
      data: []
    }
  },
  computed: {
    headers () {
      const headers = [
        { text: 'Producto', align: 'start', value: 'productName' },
        { text: 'Periodo', align: 'start', value: 'period' },
        { text: 'Total', align: 'start', value: 'amount' }
      ]
      // const keys = uniq(flattenDeep(this.data.map(k => Object.keys(k))))
      // keys.forEach(key => {
      //   if (key !== 'product' && key !== 'productName') {
      //     headers.push({ text: key, value: key, align: 'end', sortable: false })
      //   }
      // })
      return headers
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') this.isOpen = false
    },
    open (products, category) {
      this.isOpen = true
      // const parsedProducts = products.reduce((acc, curr) => {
      //   const prodIndex = (acc || []).findIndex(p => p.product === curr.product)
      //   if (prodIndex < 0) {
      //     acc.push({ product: curr.product, productName: curr.productName, [curr.period]: curr.amount })
      //   } else {
      //     acc[prodIndex][curr.period] = curr.amount
      //   }
      //   return acc
      // }, [])
      this.data = products
      this.category = category
      this.total = products.reduce((acc, curr) => acc + curr.amount, 0)
    },
    close () {
      this.isOpen = false
    }
  }
}
</script>
